(function (root) {
  var LIMITS = {
    bytes: 2048,
    pages: 20,
    products: 50,
    lookalikes: 10,
    entry: 64,
    path: 200,
  };
  var CACHE = { prefix: 'profile:', ttl: 3600000 };
  var TIMEOUT = 1500;
  var DEVICE_ID = { key: 'trybe_did', shape: /^[A-Za-z0-9-]{8,64}$/ };
  var DEVICES = ['mobile', 'tablet', 'desktop'];

  var pure = {};

  // The user agent decides; the viewport only breaks ties for agents without a clear signal (an iPad reads as Macintosh).
  pure.detectDevice = function (userAgent, viewportWidth, touchPoints) {
    var ua = String(userAgent || '');
    var points = Number(touchPoints) || 0;
    var wide = typeof viewportWidth === 'number' && viewportWidth > 0 ? viewportWidth : 0;
    if (/iPad|Tablet|PlayBook|Silk|Kindle/i.test(ua)) return DEVICES[1];
    if (/Android/i.test(ua) && !/Mobile/i.test(ua)) return DEVICES[1];
    if (/Macintosh/i.test(ua) && points > 1) return DEVICES[1];
    if (/Mobi|iPhone|iPod|Windows Phone|Opera Mini|IEMobile/i.test(ua)) return DEVICES[0];
    if (wide > 0 && points > 0) return wide < 768 ? DEVICES[0] : wide < 1024 ? DEVICES[1] : DEVICES[2];
    return DEVICES[2];
  };

  // Lower case, no query, hash, trailing slash or language prefix; null when nothing usable remains.
  pure.normalizePath = function (candidate) {
    if (typeof candidate !== 'string') return null;
    var trimmed = candidate.trim();
    if (trimmed === '') return null;
    var scheme = trimmed.match(/^[a-z][a-z0-9+.-]*:\/\/[^/?#]*([^?#]*)/i);
    var route = scheme ? (scheme[1] || '/') : trimmed;
    if (route.charAt(0) !== '/') return null;
    route = route.split('#')[0].split('?')[0].toLowerCase();
    route = route.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/|$)/, '').replace(/\/+$/, '');
    if (route === '') route = '/';
    if (/\s/.test(route) || route.length > LIMITS.path) return null;
    return route;
  };

  function wholeCount(raw) {
    var number = typeof raw === 'number' && isFinite(raw) ? raw : null;
    return number === null || number < 0 ? null : Math.floor(number);
  }

  function numericIds(raw, cap) {
    var ids = [];
    if (!Array.isArray(raw)) return ids;
    raw.forEach(function (candidate) {
      if (ids.length >= cap) return;
      var id = String(candidate == null ? '' : candidate).trim();
      if (/^[0-9]+$/.test(id) && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function uniquePaths(raw, cap) {
    var routes = [];
    if (!Array.isArray(raw)) return routes;
    raw.forEach(function (candidate) {
      if (routes.length >= cap) return;
      var route = pure.normalizePath(candidate);
      if (route !== null && routes.indexOf(route) === -1) routes.push(route);
    });
    return routes;
  }

  pure.entryClass = function (entry) {
    var source = entry && typeof entry === 'object' ? entry : {};
    var label = String(source.utm_source || source.referrer_host || '');
    label = label.trim().toLowerCase().replace(/^www\./, '').slice(0, LIMITS.entry);
    return label === '' ? 'direct' : label;
  };

  // The endpoint's answer in the short names the checkout extension reads; anything outside the list is dropped.
  pure.mapProfile = function (answer, device) {
    var source = answer && typeof answer === 'object' ? answer : {};
    var short = { v: 1 };
    if (typeof source.returning === 'boolean') short.ret = source.returning;
    var sessions = wholeCount(source.sessions);
    if (sessions !== null) short.ses = sessions;
    short.dsf = wholeCount(source.days_since_first);
    short.pg = uniquePaths(source.pages, LIMITS.pages);
    if (DEVICES.indexOf(device) !== -1) short.dev = device;
    short.ent = pure.entryClass(source.entry);
    short.pp = numericIds(source.past_products, LIMITS.products);
    var orders = wholeCount(source.orders_count);
    if (orders !== null) short.oc = orders;
    short.cam = wholeCount(source.child_age_months);
    short.ll = numericIds(source.lookalike_top, LIMITS.lookalikes);
    return short;
  };

  pure.byteLength = function (text) {
    var encoder = typeof TextEncoder === 'undefined' ? null : new TextEncoder();
    return encoder === null ? unescape(encodeURIComponent(text)).length : encoder.encode(text).length;
  };

  // Over the limit the newest pages go first, then the past products; still over it, nothing is written.
  pure.serializeProfile = function (profile) {
    var draft = JSON.parse(JSON.stringify(profile));
    var oversized = function () {
      return pure.byteLength(JSON.stringify(draft)) > LIMITS.bytes;
    };
    ['pg', 'pp'].forEach(function (field) {
      while (oversized() && Array.isArray(draft[field]) && draft[field].length > 0) draft[field].pop();
    });
    return oversized() ? null : JSON.stringify(draft);
  };

  pure.cacheKey = function (anonymousId) {
    return CACHE.prefix + String(anonymousId);
  };

  pure.isCacheFresh = function (entry, now, ttl) {
    var shaped = entry && typeof entry === 'object' && typeof entry.t === 'number' && entry.p && typeof entry.p === 'object';
    if (!shaped) return false;
    var age = now - entry.t;
    return age >= 0 && age < (typeof ttl === 'number' ? ttl : CACHE.ttl);
  };

  pure.readAnonFromCookie = function (cookies) {
    var found = ('; ' + String(cookies || '')).match(/;\s*trybe_did=([A-Za-z0-9-]{8,64})(?:;|$)/);
    return found === null ? null : found[1];
  };

  pure.validAnon = function (candidate) {
    var usable = typeof candidate === 'string' && DEVICE_ID.shape.test(candidate);
    return usable ? candidate : null;
  };

  // Only what differs is written; a string sets the profile, null clears a stale one, undefined leaves it alone.
  pure.diffAttributes = function (current, names, device, profileText) {
    var held = current && typeof current === 'object' ? current : {};
    var changes = {};
    if (device && held[names.device] !== device) changes[names.device] = device;
    if (profileText && held[names.profile] !== profileText) changes[names.profile] = profileText;
    if (profileText === null && held[names.profile]) changes[names.profile] = '';
    return changes;
  };

  pure.LIMIT_BYTES = LIMITS.bytes;
  pure.CACHE_TTL_MS = CACHE.ttl;
  root.themeProfileBridge = pure;
  if (!root.document || typeof root.fetch !== 'function') return;

  var page = root.document;
  var tag = page.currentScript;
  var config = tag && tag.dataset ? tag.dataset : {};
  var endpoint = config.endpoint;
  // The attribute names come from the one helper of the cart fields (theme.attributes, assets/theme.js loads first).
  var fields = root.theme && typeof root.theme.attributes === 'function' ? root.theme.attributes : null;
  if (!endpoint || fields === null) return;
  var nameOf = function (kind) {
    var single = {};
    single[kind] = '';
    return Object.keys(fields(single))[0];
  };
  var names = { profile: nameOf('profile'), device: nameOf('device'), offer: nameOf('offer') };
  var routes = page.body && page.body.dataset ? page.body.dataset : {};
  if (!routes.cartUrl || !routes.cartUpdateUrl) return;

  var state = { device: null, profileText: undefined, writing: false };

  function pixelKey() {
    var pixel = root.trybeShopifyPixel;
    var key = pixel && typeof pixel.key === 'string' ? pixel.key.trim() : '';
    return key;
  }

  function ownDevice() {
    try {
      var agent = root.navigator || {};
      return pure.detectDevice(agent.userAgent, root.innerWidth, agent.maxTouchPoints);
    } catch (failure) {
      return DEVICES[2];
    }
  }

  // The device id exists only after consent, because the pixel creates it then and removes it on withdrawal.
  function anonymousId() {
    var cookieId = pure.readAnonFromCookie(page.cookie);
    if (cookieId !== null) return cookieId;
    try {
      return pure.validAnon(root.localStorage.getItem(DEVICE_ID.key));
    } catch (failure) {
      return null;
    }
  }

  function readCache(anonId) {
    try {
      var stored = root.sessionStorage.getItem(pure.cacheKey(anonId));
      var entry = stored ? JSON.parse(stored) : null;
      return pure.isCacheFresh(entry, Date.now(), CACHE.ttl) ? entry.p : null;
    } catch (failure) {
      return null;
    }
  }

  function writeCache(anonId, profile) {
    try {
      root.sessionStorage.setItem(pure.cacheKey(anonId), JSON.stringify({ t: Date.now(), p: profile }));
    } catch (failure) {
      /* a full or blocked storage only costs the next page its cache */
    }
  }

  function askWithDeadline(url, options, milliseconds) {
    var stopper = typeof AbortController === 'undefined' ? null : new AbortController();
    if (stopper !== null) options.signal = stopper.signal;
    var deadline = root.setTimeout(function () {
      if (stopper !== null) stopper.abort();
    }, milliseconds);
    var done = function () {
      root.clearTimeout(deadline);
    };
    return root.fetch(url, options).then(
      function (answer) {
        done();
        return answer;
      },
      function (failure) {
        done();
        throw failure;
      },
    );
  }

  function askProfile(anonId, device) {
    var fromCache = readCache(anonId);
    if (fromCache) return Promise.resolve(fromCache);
    var key = pixelKey();
    if (key === '') return Promise.resolve(null);
    var query = '?key=' + encodeURIComponent(key) + '&anon=' + encodeURIComponent(anonId);
    var options = { method: 'GET', credentials: 'omit', headers: { Accept: 'application/json' } };
    return askWithDeadline(endpoint + query, options, TIMEOUT)
      .then(function (answer) {
        if (!answer.ok) throw new Error('profile ' + answer.status);
        return answer.json();
      })
      .then(function (payload) {
        var profile = pure.mapProfile(payload, device);
        writeCache(anonId, profile);
        return profile;
      })
      .catch(function () {
        return null;
      });
  }

  function readCart() {
    return root.fetch(routes.cartUrl + '.js', { headers: { Accept: 'application/json' } }).then(function (answer) {
      if (!answer.ok) throw new Error('cart ' + answer.status);
      return answer.json();
    });
  }

  function writeCart(device, profileText) {
    if (state.writing) return Promise.resolve();
    state.writing = true;
    return readCart()
      .then(function (cart) {
        var held = (cart && cart.attributes) || {};
        // An offer checkout owns its cart.
        if (String(held[names.offer] || '').trim() !== '') return undefined;
        var changes = pure.diffAttributes(held, names, device, profileText);
        if (Object.keys(changes).length === 0) return undefined;
        return root.fetch(routes.cartUpdateUrl + '.js', {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ attributes: changes }),
        });
      })
      .catch(function () {})
      .then(function () {
        state.writing = false;
      });
  }

  function sync() {
    var device = ownDevice();
    var anonId = anonymousId();
    state.device = device;
    var profile = anonId === null
      ? Promise.resolve(null)
      : askProfile(anonId, device).then(function (found) {
        if (!found) return undefined;
        found.dev = device;
        return pure.serializeProfile(found) || undefined;
      });
    return profile.then(function (profileText) {
      state.profileText = profileText;
      return writeCart(device, profileText);
    });
  }

  // Not paint-critical: after the load event, then once more on the first cart change in case the cart was new.
  function start() {
    var afterFirstChange = function () {
      page.removeEventListener('cart:updated', afterFirstChange);
      writeCart(state.device, state.profileText);
    };
    sync().then(function () {
      page.addEventListener('cart:updated', afterFirstChange);
    });
  }

  var later = function () {
    root.setTimeout(start, 0);
  };
  if (page.readyState === 'complete') later();
  else root.addEventListener('load', later);
})(window);
